<!-- <app-welcome *ngIf="showPopup" (close)="closePopup()"></app-welcome> -->
<nav class="navbar shadow navbar-expand-md navbar-light bg-white">
  <div class="container-fluid align-items-center justify-content-center">
    <a class="notuser-logo-link" routerLink="/Home">
      <img src="/assets/logo-01.png" class="card-img" [alt]="'Logo' | transloco" height="30" />
    </a>
  </div>
</nav>
